module.exports = __webpack_public_path__ + "static/img/icon7.c3133cf2.png";